import React from 'react'
import { Button } from 'react-weui'
import { browserHistory } from 'react-router'
import { WKVisible } from '../../components/wk'
import { renderMoney, isLZWKAPP } from '../../utils'
import { toShareCardPage } from '../../utils/connectApp'
import Header from '../../components/liveroomLecturer/Header'
import MediaItem from './MediaItem'
import wxMomentImg from '../../images/wx-moment.png'
import wxMenuImg from '../../images/wx-menu.png'
import tuijianImg from '../../images/resell/icon-tuijian.png'



class ResellPublishModal extends React.Component {
    onClickPublishClose () {
        this.props.onClickPublishClose()
        // this.setState({ isShowModal: false, publishData: null })
    }
    onClickGetInviteCard (type, id) {
        if (type === 'vip') {
            type = 'liveroom_vip'
        }
        if (isLZWKAPP()) {
            toShareCardPage(type, id)
        } else {
            location.assign(`/${type}/${id}/sharecard/?is_resell_center=True`)
        }
    }
    getResellField (item) {
        if (item.liveroom_resell_info) {
            return '预计佣金'
        } else {
            return '预计邀请奖励'
        }
    }
    getMiddleText (publishData, vipInfo) {
        if (publishData.type === 'liveroom') {
            if (vipInfo && vipInfo.vip_fee !== 0) {
                return 'VIP会员/付费专栏/付费课程'
            } else {
                return '付费专栏/付费课程'
            }
        } else {
            return `金额：¥${renderMoney(publishData.object.money || 0)}`
        }
    }
    getBottomText (publishData, resellInfo) {
        if (isLZWKAPP()) {
            return `邀请好友听课，赚¥${renderMoney(resellInfo.percent * publishData.object.money / 100)}元`
        }
        if (publishData.type === 'liveroom') {
            return `${this.getResellField(publishData)}：${resellInfo.percent}%`
        } else {
            return `${this.getResellField(publishData)}：${resellInfo.percent}%（¥${renderMoney(resellInfo.percent * publishData.object.money / 100)}）`
        }
    }
    render() {
        const { publishData, vipInfo } = this.props
        // resell_info 优先级选择
        let resellInfo
        // if (publishData.liveroom_resell_info) {
        //     resellInfo = publishData.liveroom_resell_info
        // } else {
        //     resellInfo = publishData.resell_info
        // }
        resellInfo = publishData.resell_info
        const type = publishData.type
        return (
            <div className='resell-publish-modal'>
                <div className="new_modal">
                    <MediaItem
                        content={{
                            cover: publishData.object.cover_url,
                            topText: publishData.object.name,
                            middleText: this.getMiddleText(publishData, vipInfo),
                            bottomText: this.getBottomText(publishData, resellInfo),
                        }}
                    />
                    <div className="item" style={{position: 'relative'}}>
                        <Header title='推广方式1：邀请卡' />
                        <img className="icon-tuijian" src={tuijianImg}/>
                        <Button className="btn-my-card" onClick={e => this.onClickGetInviteCard(publishData.object.object_type, publishData.object.id)}>获取我的邀请卡</Button>
                    </div>
                    <WKVisible create={!isLZWKAPP()}>
                        <div className="item share">
                            <Header title='推广方式2：手机直接分享' />
                            <div className="line step-1">
                                <p>不要关闭此弹窗，直接点击右上角 <img src={wxMenuImg} alt=""/></p>
                            </div>
                            <div className="line step-2">
                                <p>选择分享至 <img src={wxMomentImg} alt=""/></p>
                            </div>
                        </div>
                    </WKVisible>
                    <div className="item url">
                        {isLZWKAPP() ?
                            <Header title='推广方式2：短链接' />
                            :
                            <Header title='推广方式3：短链接' />
                        }
                        <div className="line">
                            <a>{publishData.short_url}</a>
                            <label id='copy-btn' className="copy-btn" data-clipboard-text={publishData.short_url}>复制链接</label>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ResellPublishModal


// WEBPACK FOOTER //
// ./src/pages/resell/ResellPublishModalNew.js